<div class="w-full overflow-visible! m-0! flex flex-col">
  <div class="flex items-center justify-between gap-2 overflow-hidden">
    <label class="form-label truncate flex-1 m-0">
      {{ label }}
    </label>
    <div class="flex gap-3 shrink-0 max-sm:gap-2.5">
      <label class="flex items-center gap-1 cursor-pointer m-0">
        <input
          [id]="'ad_' + key"
          type="radio"
          [name]="'calendarType_' + key"
          value="AD"
          [(ngModel)]="calendarType"
          [disabled]="readonly"
          class="w-3.5 h-3.5 accent-primary cursor-pointer shrink-0 m-0 disabled:opacity-50 disabled:cursor-not-allowed"
        />
        <span
          class="text-[11.5px] font-semibold text-text whitespace-nowrap select-none"
          [class.font-bold]="calendarType === 'AD'"
          [class.text-primary]="calendarType === 'AD'"
          [class.opacity-50]="readonly"
          >AD</span
        >
      </label>
      <label class="flex items-center gap-1 cursor-pointer m-0">
        <input
          [id]="'bs_' + key"
          type="radio"
          [name]="'calendarType_' + key"
          value="BS"
          [(ngModel)]="calendarType"
          [disabled]="readonly"
          class="w-3.5 h-3.5 accent-primary cursor-pointer shrink-0 m-0 disabled:opacity-50 disabled:cursor-not-allowed"
        />
        <span
          class="text-[11.5px] font-semibold text-text whitespace-nowrap select-none"
          [class.font-bold]="calendarType === 'BS'"
          [class.text-primary]="calendarType === 'BS'"
          [class.opacity-50]="readonly"
          >BS</span
        >
      </label>
    </div>
  </div>

  <div class="w-full relative mt-2">
    @if (calendarType === "AD") {
      <app-ad-date-picker-wrapper
        [date]="selectedDate"
        [placeholder]="'Select date (AD)'"
        [dateRestriction]="dateRestriction"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [enableTime]="enableTime"
        [disabled]="readonly"
        (dateSelected)="updateAdDate($event)"
      >
      </app-ad-date-picker-wrapper>
    }

    @if (calendarType === "BS") {
      <app-nepali-date-picker-wrapper
        [date]="selectedDate"
        [placeholder]="'Select date (BS)'"
        [dateRestriction]="dateRestriction"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [enableTime]="enableTime"
        [disabled]="readonly"
        dateIn="AD"
        (dateSelected)="updateBsDate($event)"
      >
      </app-nepali-date-picker-wrapper>
    }
  </div>
</div>
